import { http } from "src/axios";
import ClientConfigServices from "src/Services/ClientConfigServices";
import type { ScopeDraft } from "../../CustomersCreate/ScopesTable/types";

export interface AddScopeResponse {
  message: string;
}

export async function addScope(accountId: string | number, scopeData: ScopeDraft): Promise<AddScopeResponse> {
  const response = await http.post(`/api/v1/accounts/${accountId}/scopes`, scopeData);
  return { message: response.data.message };
}

const updateAccountsScopes = async ({
  accountID,
  scopeID,
  inputData,
}: {
  accountID: number;
  scopeID: number;
  inputData: any;
}) => {
  try {
    const response = await ClientConfigServices.updateScope({
      accountID,
      scopeID,
      data: inputData,
    });

    if (response.status !== 200) {
      throw new Error("Error updating scope, response status is not 200");
    }
  } catch (e) {
    throw e;
  }
};

const GetAccountsScopesData = async (setTableData: any, setLoader: any, accountID: any) => {
  try {
    setLoader(true);
    let response = await ClientConfigServices.GetAccountsScopes(accountID);
    if (response.status === 200) {
      setTableData(response?.data.scopes);
      setLoader(false);
    }
  } catch (e) {
    // @ts-ignore
    if (e.response.status === 404) {
      setTableData([]);
    }
    setLoader(false);
  }
};

interface DeleteScopes {
  AccountsID: number;
  scopesID: number;
}

const deleteScopes = async ({ AccountsID, scopesID }: DeleteScopes) => {
  try {
    const response = await ClientConfigServices.deleteScopes(AccountsID, scopesID);

    if (response.status !== 200) {
      throw new Error("Error deleting scope, response status is not 200");
    }
  } catch (e) {
    throw e;
  }
};

export { GetAccountsScopesData, updateAccountsScopes, deleteScopes };
